<template>
  <v-container>
    <component :is="getServiziComponent" />
  </v-container>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  import Index from './../components/magazzino/services/Index'
  import Insert from './../components/magazzino/services/Insert'

  export default {
    name: 'MagazzinoAccessori',
    components: {
      Index,
      Insert
    },
    computed: {
      ...mapGetters([
        'getServiziComponent'
      ])
    },
    methods: {
      ...mapMutations([
        'CHANGE_SERVIZI_COMPONENT'
      ])
    },
    destroyed() {
      this.CHANGE_SERVIZI_COMPONENT('Index')
    }
  }
</script>

<style>
</style>